import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="activeModal.close(false)">
      </button>
    </div>
    <div class="modal-body">
      <p>{{ message }}</p>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="activeModal.close(false)">
        {{ btnCancelText }}
      </button>
      <button
        type="button"
        class="btn btn-danger"
        (click)="activeModal.close(true)">
        {{ btnOkText }}
      </button>
    </div>
  `
})
export class ConfirmDialogComponent {
  @Input() title: string = 'Bestätigung erforderlich';
  @Input() message: string = 'Möchtest du dieses Element wirklich löschen?';
  @Input() btnOkText: string = 'Löschen';
  @Input() btnCancelText: string = 'Abbrechen';

  constructor(public activeModal: NgbActiveModal) {}
}
